import { Divider, Paper, Stack } from "@mui/material";
import { ActionRow } from "Components/Shared/ActionRow";
import { Resources, useResource } from "Translations/Resources";

const PAGE_RESOURCES = Resources.Hunter.LicensePaymentPending;
const LICENSE_DETAIL_RESOURCES = Resources.Pages.Content.LicenseDetail;

type Props = {
  onShowPaymentDetails: () => void;
  onOrderAnotherLicense: () => void;
  onCancelOrder: () => void;
  isCancelDisabled?: boolean;
};

export const PendingLicenseActions = ({
  onShowPaymentDetails,
  onOrderAnotherLicense,
  onCancelOrder,
  isCancelDisabled,
}: Props) => {
  const { t } = useResource();

  return (
    <Paper
      sx={{
        p: 1,
        width: "100%",
        overflow: "hidden",
        borderRadius: "10px",
        height: "fit-content",
      }}
    >
      <Stack divider={<Divider sx={{ borderColor: "grey.100" }} />}>
        <ActionRow
          variant="primary"
          title={t(PAGE_RESOURCES.NotPaidYetLink)}
          subtitle={t(PAGE_RESOURCES.NotPaidYetSubtitle)}
          onClick={onShowPaymentDetails}
        />
        <ActionRow
          variant="primary"
          title={t(PAGE_RESOURCES.OrderAnotherLicense)}
          onClick={onOrderAnotherLicense}
        />
        <ActionRow
          variant="destructive"
          title={t(LICENSE_DETAIL_RESOURCES.CancelOrder)}
          onClick={onCancelOrder}
          isDisabled={isCancelDisabled}
        />
      </Stack>
    </Paper>
  );
};
